// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__gKXs0","insightsList":"newBusinessInsightsMenu_insightsList__253BS","active":"newBusinessInsightsMenu_active__39HRh"};